import React, { PureComponent } from 'react';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  injectStripe,
} from 'react-stripe-elements';
import { message, Button } from 'antd';
import get from 'lodash/get';

import PaymentIcon from './components/PaymentIcon';
import WalletIcon from './components/WalletIcon';
import Modal from '../../../../../components/Modal';
import { updateCustomerPaymentMethod } from '../api';
import BookingPageContext from '../../../context';

class UpdatePaymentModal extends PureComponent {
  static contextType = BookingPageContext;

  state = {
    brand: null,
    fieldsIncomplete: new Set(),
    fieldsComplete: new Set(),
    fieldRequired: 3,
    isLoading: false,
  };

  handleInputChange = (change) => {
    const { elementType } = change;
    const { fieldsIncomplete, fieldsComplete, brand: knownBrand } = this.state;
    if (!change.empty && !change.complete) fieldsIncomplete.add(elementType);
    else fieldsIncomplete.delete(elementType);
    if (change.complete) fieldsComplete.add(elementType);
    else fieldsComplete.delete(elementType);
    this.setState({
      fieldsIncomplete: new Set(fieldsIncomplete),
      fieldsComplete: new Set(fieldsComplete),
      brand: change.brand === 'unknown' ? knownBrand : change.brand,
    });
  };

  submit = async () => {
    const tokenResponse = await this.props.stripe.createToken();
    const { token, error } = tokenResponse;

    if (error?.message) {
      message.error(error.message);
      return;
    }

    if (!token) return;

    try {
      this.setState({ isLoading: true });

      await updateCustomerPaymentMethod({
        bookingId: this.props.booking.bookingId,
        customerId: this.props.booking.customer.id,
        paymentMethodId: this.props.booking.paymentMethodId,
        bookingUuid: this.props.booking.bookingUuid,
        segment: this.props.booking.segment,
        token: token.id,
      });

      this.props.closePopup();
      this.context.reloadBooking();
    } catch (requestError) {
      message.error(get(requestError, 'response.data.message', requestError.message));
      this.setState({ isLoading: false });
    }
  };

  isDisabled = () => {
    const { fieldsComplete, fieldRequired } = this.state;
    return fieldsComplete.size !== fieldRequired;
  };

  isNewCard = () => {
    const { fieldsIncomplete, fieldsComplete, isLoading } = this.state;
    return fieldsIncomplete.size !== 0 || fieldsComplete.size > 0 || isLoading;
  };

  isWallet() {
    const { card } = this.props;
    const isNewCard = this.isNewCard();
    return card.source && card.source !== 'card' && !isNewCard;
  }

  render() {
    const { card, closePopup, openedPopup } = this.props;
    const { brand, isLoading } = this.state;
    const isNewCard = this.isNewCard();

    return (
      <Modal
        title="Update payment method"
        visible={openedPopup === 'EditPaymentDetailsModal'}
        footer={
          <Button type="primary" disabled={this.isDisabled()} loading={isLoading} onClick={this.submit}>
            Update payment
          </Button>
        }
        onCancel={closePopup}
      >
        <form>
          <div style={{ display: 'flex' }}>
            {this.isWallet() && (
              <div style={{ marginRight: 8 }}>
                <WalletIcon type={card.source} />
              </div>
            )}
            <div>
              <PaymentIcon brand={brand || card.brand} className="payment-icon" />
            </div>
            <div style={{ flex: 1, paddingLeft: 8 }}>
              <CardNumberElement
                onChange={this.handleInputChange}
                placeholder={!isNewCard ? `**** **** **** ${card.last4}` : 'Card number'}
              />
            </div>
            <div style={{ minWidth: 68, paddingLeft: 8 }}>
              <CardExpiryElement
                onChange={this.handleInputChange}
                placeholder={!isNewCard ? `${card.expiryMonth}/${(card.expiryYear + '').slice(2)}` : 'MM / YY'}
              />
            </div>
            <div style={{ minWidth: 40, paddingLeft: 8 }}>
              <CardCvcElement
                onChange={this.handleInputChange}
                placeholder={!isNewCard ? '***' : 'CVC'}
              />
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

export default injectStripe(UpdatePaymentModal);
